<template>
    <div id="container-modal" class="absolute w-full h-full top-0 z-10">
        <div id="subcontainer-modal" class="relative m-auto top-modal-desktop rounded-smoth overflow-hidden w-modal max-md:w-full max-md:top-modal-mobile" :class="[route.params.detailData == 'carrito-de-compras' ? ['px-special', 'h-modal-desk-sc', 'max-md:h-modal-mobile-sc'] : ['px-third', 'h-modal-desk', 'max-md:h-screen' ,'max-md:px-special']]">
            <div id="modal-header" class="font-bloggerB text-content-subtitle-desktop flex justify-between h-header-modal relative items-center text-white bg-primary-color-1st px-special rounded-t-smoth dark:bg-primary-dark-color-1st max-md:text-content-subtitle-mobile max-md:h-header-modal-mobile">
                <div id="title-modal">
                    <span v-if="route.params.detailData == 'carrito-de-compras'">
                        {{ t('shopping-cart') }}
                    </span>
                    <span v-if="route.params.detailData != 'carrito-de-compras' && dataRender != undefined">
                        {{ dataRender['cat'] }}
                    </span>
                </div>
                <div id="close-modal" @click="close()" class="hover:cursor-pointer">
                    X
                </div>
            </div>
            <div id="modal-body" class="bg-white p-special h-body-modal dark:bg-primary-dark-color-2nd max-md:h-body-modal-cs-mobile" :class="[route.params.detailData != 'carrito-de-compras' ? 'rounded-b-smoth' : '']">
                <div v-if="route.params.detailData == 'carrito-de-compras'" id="shopping-cart" class="flex h-full max-md:overflow-y-scroll max-md:flex-col">
                    <div id="body-left" class="h-full w-3/5 max-md:w-full max-md:h-auto">
                        <div id="first-steps" class="flex flex-col px-special bg-gray-lite/50 rounded-smoth py-special dark:bg-primary-dark-color-4th dark:text-primary-dark-text">
                            <span class="text-ticket-desktop font-monserratR mb-min max-md:text-ticket-mobile">
                                {{ t('steps', { begin: 1, end: 2 }) }}
                            </span>
                            <span class="font-bloggerB text-content-title-desktop max-md:text-content-title-mobile">
                                {{ leyendsBuyer[0] }}
                            </span>
                            <div id="container-form" class="mt-special grid grid-cols-2 gap-4">
                                <div v-for="buyer in leyendsBuyer.slice(1,)" class="flex flex-col text-label-desktop max-md:text-label-mobile">
                                    <label :for="'input-' + buyer.leyend" class="mb-min font-monserratM"> {{ buyer.leyend }} </label>
                                    <input :maxlength="buyer.max" @keyup="valid(buyer.var, buyer.type)" type="text" v-model="dataShoppingCart[buyer.var]" :name="'input-' + buyer.leyend" :id="'input-' + buyer.leyend" class="form-input max-md:text-content-mobile" :placeholder="buyer.text">
                                </div>
                            </div>
                        </div>
                        <div id="options-radio" class="flex justify-between mt-special px-special">
                            <div id="radio-button" class="flex p-special" v-for="option in t('put-options', {returnObjects: true})">
                                <input type="radio" checked name="colect-type" v-model="dataShoppingCart['type']" :id="'radio-colect-type-' + option['option']" class="mr-special" :value="option['alias-es']">
                                <div id="textos" class="flex flex-col">
                                    <label :for="'radio-colect-type-' + option['option']" class="flex flex-col dark:text-primary-dark-text">
                                        <span class="mb-text font-bloggerM">{{ option['option'] }}</span>
                                        <span class="font-monserratR text-label-desktop max-md:text-label-mobile">{{ option['leyend'] }}</span>
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div id="second-steps" v-if="dataShoppingCart['type'] == (t('put-options', {returnObjects: true})[0]['alias-es'])" class="flex flex-col px-special bg-gray-lite/50 rounded-smoth py-special dark:bg-primary-dark-color-4th dark:text-primary-dark-text">
                            <span class="text-ticket-desktop font-monserratR mb-min max-md:text-ticket-mobile">
                                {{ t('steps', { begin: 2, end: 2 }) }}
                            </span>
                            <span class="font-bloggerB text-content-title-desktop max-md:text-content-title-mobile">
                                {{ destinationData[0] }}
                            </span>
                            <div id="container-form" class="mt-special grid grid-flow-row-dense grid-cols-2 gap-4 font-monserratM text-label-desktop max-md:text-label-mobile">
                                <div v-for="destination in destinationData.slice(1, destinationData.length - 2)" class="flex flex-col">
                                    <label :for="'input-' + destination.leyend" class="mb-min"> {{ destination.leyend }} </label>
                                    <input :maxlength="destination.max" @keyup="valid(destination.var, destination.type)" type="text" v-model="dataShoppingCart[destination.var]" :name="'input-' + destination.leyend" :id="'input-' + destination.leyend" class="form-input max-md:text-content-mobile">
                                </div>
                                <div class="flex flex-col col-span-2">
                                    <label :for="'input-' + destinationData[destinationData.length - 2].leyend" class="mb-min"> {{
                                        destinationData[destinationData.length - 2].leyend }} </label>
                                    <textarea @keyup="valid(destinationData[3]['var'], destinationData[3]['type'])" v-model="dataShoppingCart[destinationData[3]['var']]" :name="'input-' + destinationData[destinationData.length - 2].leyend" :id="'input-' + destinationData[destinationData.length - 2].leyend" class="form-input resize-none" rows="6"></textarea>
                                    <span class="text-ticket-desktop mt-text max-md:text-ticket-mobile">{{ destinationData[destinationData.length - 1] }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div id="body-right" :class="[data != null ? 'max-md:h-1/2' : 'max-md:h-total-space']" class="flex flex-col pl-special w-2/5 max-md:w-full max-md:pl-0 max-md:pt-special">
                        <div id="subcontainer-body-right" class="bg-gray-lite/50 dark:bg-primary-dark-color-4th w-full h-full rounded-smoth">
                            <div v-if="data != null" id="container-products" class="overflow-y-scroll h-body-modal pl-special py-special">
                                <HorizontalCard v-for="product, index in data" @new-qty="(qty) => math(index, qty)" @del="() => del(index)" :data="product" />
                            </div>
                            <div id="container-total" :class="[data == null ? 'max-md:h-full' : 'max-md:h-total-space']" class="h-total-space flex items-center justify-between px-special">
                                <span class="text-content-title-desktop ml-special font-bloggerM text-primary-text dark:text-secondary-color-2nd max-md:text-content-title-mobile">
                                    Total
                                </span>
                                <span class="font-bloggerB text-big-text-desktop ml-special text-primary-color-1st dark:text-secondary-color-2nd max-md:text-big-text-mobile">
                                    {{ 'L. ' + total }}
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-if="route.params.detailData != 'carrito-de-compras' && dataRender != undefined" id="detail-product" class="grid grid-cols-2 gap-4 h-full max-md:grid-cols-1">
                    <div id="body-left" class="h-full relative rounded-smoth overflow-hidden w-full">
                        <div id="container-img-product" class="h-full w-full relative">
                            <img id="img-product-detail" :src="dataRender['url']" alt="" class="w-full h-full object-none">
                        </div>
                    </div>
                    <div id="body-right" class="flex flex-col">
                        <div id="container-data-product" class="flex flex-col max-md:mb-special">
                            <span class="text-big-text-desktop font-bloggerB mb-text max-md:text-big-text-mobile dark:text-primary-dark-text">
                                {{ dataRender['name'] }}
                            </span>
                            <pre class="text-gray-text font-monserratM text-content-desktop mb-special max-md:text-content-mobile dark:text-gray-lite" v-html="dataRender['description']"></pre>
                            <span class="text-principal-desktop font-bloggerM text-primary-color-1st dark:text-secondary-color-1st mb-special max-md:text-principal-mobile">
                                L. {{ dataRender['price'].replace('$', '') }}
                            </span>
                            <div v-if="dataColors.length > 0" id="container-variants" class="grid grid-cols-6 gap-1 mb-special">
                                <div v-for="colors, index in dataColors" class="relative rounded-smoth overflow-hidden w-full h-img-variant hover:cursor-pointer" @click="changePreview(index)">
                                    <div id="container-img-variant" class="relative w-full h-full">
                                        <img :src="colors['url']" :alt="colors['name'] + 'Color' + colors['color']" class="w-full h-full object-cover">
                                    </div>
                                </div>
                            </div>
                            <div v-if="dataSizes.length > 0 && dataSizes[0]['size'] != ''" id="container-variants-size" class="flex flex-col">
                                <div class="mb-text font-bloggerB text-secondary-desktop max-md:text-secondary-mobile dark:text-primary-dark-text">
                                    <span class="select-none">
                                        {{ t('menu', { returnObjects: true })[4].texts[0] }}
                                    </span>
                                </div>
                                <div id="container-size" class="grid grid-cols-8 gap-2">
                                    <span v-for="size in dataSizes" @click="dataRender['size'] = size['size']; dataRender['idSize'] = size['id']; dataRender['total'] = size['qty']" class="w-full text-center py-middle rounded-smoth font-bloggerM text-content-desktop hover:cursor-pointer max-md:text-content-mobile" :class="[dataRender['size'] == size['size'] ? ['bg-primary-color-2nd', 'text-white', 'dark:bg-primary-dark-color-1st'] : ['text-white', 'bg-primary-color-1st', 'dark:bg-secondary-color-4th', 'dark:text-secondary-color-3rd']]"> {{ size['size'] }} </span>
                                </div>
                            </div>
                        </div>
                        <div id="container-buttons-detail" class="flex justify-end mt-auto items-center max-md:mt-auto">
                            <ButtonV :text-button="buttonsData['cancel']" type="secondary" @click="close()" class="mr-special" />
                            <ButtonV :text-button="buttonsData['store-add-button']" type="primary" @click="addProduct()" />
                        </div>
                    </div>
                </div>
            </div>
            <div v-if="route.params.detailData == 'carrito-de-compras'" id="modal-footer" class="bg-white h-header-modal dark:bg-primary-dark-color-2nd rounded-b-smoth flex items-center justify-end max-md:h-footer-modal-mobile">
                <div id="buttons-shopping-cart" class="flex justify-end px-special">
                    <ButtonV :text-button="buttonsData['shopping-cart-cancel']" @click="deleteShoppingCart()" type="secondary" class="mr-special" />
                    <ButtonV :text-button="buttonsData['shopping-cart-confirm']" @click="confirmShoppingCart()" type="primary" />
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { onBeforeMount, ref, watchEffect } from 'vue';
import { useTranslation } from 'i18next-vue';
import router from '@/router';
import { productStore } from '@/stores/product';
import { shoppingCart } from '@/stores/shoppingCart';
import { orderStore } from '@/stores/orders';
import { generalStore } from '@/stores';
import { categoriesStore } from '@/stores/categories';

import ButtonV from './Button.vue';
import HorizontalCard from './HorizontalCard.vue';

let { t } = useTranslation();
const storeC = categoriesStore();
const storeP = productStore();
const storeS = shoppingCart();
const storeO = orderStore();
const store = generalStore();
const route = store.route;

var data = ref({});
var dataRender = ref([]);
var dataColors = ref([]);
var dataSizes = ref([]);
var total = ref(0);

var dataShoppingCart = ref({});
dataShoppingCart.value['type'] = 'local'

document.body.classList.add('overflow-hidden')

let leyendsBuyer = t('buyer-data', { returnObjects: true });
let destinationData = t('destination-data', { returnObjects: true });
let buttonsData = t('buttons', { returnObjects: true });

watchEffect(async () => {
    if (route.params.detailData == 'carrito-de-compras') {
        data.value = storeS.getShoppingCart()
        if (data.value != null) {
            total.value = storeS.calculateTotal()
        } else {
            total.value = 0;
        }
    }
})

const addProduct = () => {
    if (dataSizes.value[0]['size'] == '') {
        dataRender.value['idSize'] = dataSizes.value[0]['id'];
        dataRender.value['total'] = dataSizes.value[0]['qty'];
    }
    storeS.newProduct(dataRender.value) == 'ok' ? close() : '';
}


/**
 * Function used to validate data on form in realtime
 * @param data key on the data array
 * @param type type data (number or text)
 */
const valid = (data, type) => {
    if (dataShoppingCart.value[data]) {
        var size = ref((dataShoppingCart.value[data].toString().length));
        if (size.value > 0) {
            var lastChar = ref(dataShoppingCart.value[data][size.value - 1].toString());
            if (lastChar.value.charCodeAt(0) != 32) {
                if (!(store.validChar(lastChar.value)) && !(store.validNum(lastChar.value))) {
                    dropChar(data, size.value)
                    return
                } else {
                    if ((type == 'number') && (store.validNum(lastChar.value))) {
                        if ((data == 'phone' && size.value == 4)) {
                            dataShoppingCart.value[data] += '-'
                        }

                        if ((data == 'dni')) {
                            if (size.value == 4 || size.value == 9) {
                                dataShoppingCart.value[data] += '-'
                            }
                        }
                    }

                    if ((type == 'number') && (store.validChar(lastChar.value))) {
                        dropChar(data, size.value)
                    }

                    if ((type == 'text') && (store.validNum(lastChar.value))) {
                        dropChar(data, size.value)
                    }
                }
            }
        }
    }
}

/**
 * Function used to delete a last char
 * @param data key on the data array
 * @param size array size
 */
const dropChar = (data, size) => {
    dataShoppingCart.value[data] = ((dataShoppingCart.value[data]).toString()).substring(0, size - 1);
}

/**
 * Function that allows us to make changes in the quantity of a product when using the + or - of the shopping cart, in turn, in each change it calculates the total amount to pay for the shopping cart
 * @param index Is the position of the product in the shoppping cart array
 * @param qty Is the new qty of the product
 */
const math = (index, qty) => {
    const data = {
        index: index,
        qty: qty
    }
    storeS.updateQty(data);
    total.value = storeS.calculateTotal();
}

const del = (index) => {
    storeS.delProduct(index);
}

/**
 * Function used to decide how to close the modal
 */
const close = () => {
    document.body.classList.remove('overflow-hidden')
    router.replace('/tienda');
}

/** 
 * Function used to remove the shopping cart and reset the value of the total variable to 0
 */
const deleteShoppingCart = () => {
    if (storeS.getShoppingCart() != null) {
        storeS.deleteShoppingCart();
        storeS.handlerDelShoppingCart();
        data.value = null
        total.value = 0;
    }
}


const confirmShoppingCart = () => {
    dataShoppingCart.value['detail'] = storeS.getShoppingCart()
    var dataAddress = ((dataShoppingCart.value['department'] != undefined) || (dataShoppingCart.value['city'] != undefined) || (dataShoppingCart.value['address'] != undefined));
    var dataInfo = ((dataShoppingCart.value['name'] != undefined) || (dataShoppingCart.value['lastname'] != undefined) || (dataShoppingCart.value['dni'] != undefined) || (dataShoppingCart.value['phone'] != undefined))
    if (dataShoppingCart.value['detail'] != null) {
        if ((dataShoppingCart.value['type'] == 'domicilio')) {
            if (dataAddress && dataInfo) {
                storeO.setOrder(dataShoppingCart.value);
                close();
                return
            }
        } else {
            if (dataInfo) {
                dataShoppingCart.value['department'] = null;
                dataShoppingCart.value['city'] = null;
                dataShoppingCart.value['address'] = null;
                storeO.setOrder(dataShoppingCart.value);
                close();
                return
            }
        }
        storeS.handlerErrShoppingCart();
        return
    }
    storeS.handlerVoidShoppingCart();
}

/**
 * Function used to change Preview data on modal, the change has effect when click in the color variant
 * @param index Is the position in the array of the color variant 
 */
const changePreview = async (index) => {
    var dataTMP = dataRender.value
    dataSizes.value = await storeP.getSizeVariants(dataColors.value[index]['id'], dataColors.value[index]['color'])
    dataRender.value = dataColors.value[index]
    storeP.setDetailProduct(dataRender.value)
    dataColors.value[index] = dataTMP
}

const loadVariants = async () => {
    dataColors.value = await storeP.getProductColors(dataRender.value['id'], dataRender.value['color']);
    dataSizes.value = await storeP.getSizeVariants(dataRender.value['id'], dataRender.value['color']);
}

onBeforeMount(async () => {
    window.scrollTo(top);
    if (route.params.detailData != 'carrito-de-compras') {
        data.value = storeP.getDetailProduct();
        dataRender.value = data.value;
        loadVariants();

        if (dataRender.value == undefined) {
            var categories = ref(null)
            data.value = await storeP.getSpecificProduct(route.params.id, route.params.color)
            dataRender.value = data.value[0];
            loadVariants();
            await storeC.loadCategories('Store')
            categories.value = store.getSessionStorage('persistStoreCategories-Store');
            store.setSubMenu(categories.value);
        }
    }
})
</script>